import { FC } from 'react';
import { useLang } from '../../../../../../../hooks/use-lang';
import { Container } from '../../../../../../../components/container/container';
import { useCompanyStore } from '../../../../../../../store/use-company-store';
import { Input } from '../../../../../../../components/input/input';

interface Props {
  className: string;
  label: string;
  disabled: boolean;
  type: 'legal_address' | 'actual_address';
}

export const CompanyAddress: FC<Props> = (props) => {
  const { className, label, disabled, type } = props;
  const { t } = useLang();
  const { handleUpdateCompanyProfile, companyProfile } = useCompanyStore();
  const address = companyProfile?.[type];

  return (
    <h2 className={className}>
      {label}
      <Container label={t('Страна')}>
        <Input
          disabled={disabled}
          value={address?.country}
          onChange={(e) =>
            handleUpdateCompanyProfile({
              [type]: { ...address, country: e.currentTarget.value },
            })
          }
        />
      </Container>

      <Container label={t('Город')}>
        <Input
          disabled={disabled}
          value={address?.city}
          onChange={(e) =>
            handleUpdateCompanyProfile({
              [type]: { ...address, city: e.currentTarget.value },
            })
          }
        />
      </Container>

      <Container label={t('Адрес')}>
        <Input
          disabled={disabled}
          value={address?.address}
          onChange={(e) =>
            handleUpdateCompanyProfile({
              [type]: { ...address, address: e.currentTarget.value },
            })
          }
        />
      </Container>
    </h2>
  );
};
